import React from 'react';
import { cn } from '@/shared/lib/classnames/cn';
import { badgesVariants } from '../model/variants';
import { Badge } from './Badge';
import type { BadgesProps } from '../model/types';
export const Badges: React.FC<BadgesProps> = ({
  list,
  variant,
  position
}) => {
  return <div className={cn(badgesVariants({
    variant,
    position
  }))} data-sentry-component="Badges" data-sentry-source-file="index.tsx">
      {list.map((badge, index) => <Badge key={index} {...badge} variant={badge.type} />)}
    </div>;
};